import React, { useState, useRef } from 'react';
import Spreadsheet from "react-spreadsheet";
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from 'react-bootstrap/lib/Button';
import withStyles from 'isomorphic-style-loader/withStyles';
import Loader from '../../../components/Loader';

import messages from '../../../locale/jsonMessages';

import { AddPlusIcon, RemoveIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import s from './SpreadSheetComponent.css';
import cs from '../../../components/commonStyle.css';
import t from '../../../styles/spreadSheet.css'
import { useSelector } from 'react-redux';
import { salesUser } from '../../../helpers/DemoRestriction/demo';

function SpreadSheetComponent(props) {
    const { handleAddRow, removeRow, handleChange, loaded, data, handleSelect, language, languageCode, isRestrict, isMobileLanguageRestricted, restrictLoaded } = props;
    const { onExportCsv, onImportCsv } = props;
    const adminId = useSelector(state => state?.account?.privileges?.id)
    const columnLabels = ['Key', 'Value'];
    const [csvMode, setCsvMode] = useState('export');
    const fileInputRef = useRef(null);
    const CustomCornerIndicator = () => {
        return (
            <th className='Spreadsheet__header numberSection'>#</th>
        );
    };
    const csvOptions = [
        { value: 'export', label: <FormattedMessage  {...messages.exportCSVFile} /> },
        { value: 'import', label: <FormattedMessage  {...messages.importCSVFile} /> }
    ];

    let showLanguageOption = false;

    if (salesUser.includes(adminId)) {
        showLanguageOption = true;
    } else if (!isRestrict && isMobileLanguageRestricted == 'true') {
        showLanguageOption = true;
    }

    return (
        <div>
            <div className={cx(cs.displayFlex, cs.gap8, cs.rowGap18, cs.justifyContentSpaceBetween, s.titleBg, cs.flexWrap, cs.alignCenter)}>
                <h4 className={s.languageTitle}>{language} ({languageCode})</h4>
                {showLanguageOption && <div className={cx(cs.displayFlex, cs.gap12, cs.flexWrap, cs.alignCenter)}>
                    {csvMode === 'export' && onExportCsv && (
                        <Button
                            type="button"
                            onClick={() => onExportCsv()}
                            className={cs.linkBtnPrimaryStyle}
                        >
                            <FormattedMessage  {...messages.downloadLanguageCsv} />
                        </Button>
                    )}

                    {csvMode === 'import' && (
                        <Button
                            type="button"
                            onClick={() => fileInputRef.current && fileInputRef.current.click()}
                            className={cs.linkBtnPrimaryStyle}
                        >
                            <FormattedMessage  {...messages.importCSVFile} />
                        </Button>
                    )}
                    <select
                        value={csvMode}
                        onChange={(e) => setCsvMode(e.target.value)}
                        className={cx('commonSelectField', s.exportSelect)}
                    >
                        {csvOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>

                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".csv"
                        style={{ display: "none" }}
                        onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                                onImportCsv?.(file);
                                e.target.value = '';
                            }
                        }}
                    />

                    <Button onClick={() => removeRow()} className={cx(cs.displayFlex, cs.gap4, cs.linkBtnPrimaryStyle, cs.alignCenter)}>
                        <RemoveIcon />
                        <FormattedMessage  {...messages.removeRow} />
                    </Button>
                    <Button onClick={() => handleAddRow()} className={cx(cs.displayFlex, cs.gap4, cs.linkBtnPrimaryStyle, cs.alignCenter)}>
                        <AddPlusIcon />
                        <FormattedMessage  {...messages.addRow} />
                    </Button>

                </div>}
            </div>

            <div className={s.titleBgSection}>
                {!loaded ? <Loader type="text" /> : <Spreadsheet
                    data={data}
                    columnLabels={columnLabels}
                    onChange={(e) => handleChange(e)}
                    onSelect={handleSelect}
                    className='languageSpreadSheet'
                    CornerIndicator={CustomCornerIndicator}
                />}
            </div>
        </div>
    )
}

export default injectIntl(withStyles(s, cs, t)(SpreadSheetComponent));

